import React from 'react';
import { portfolioData } from '../mockData';

const skillGroups = [
  { key: 'Programming', field: 'programming' },
  { key: 'Robotics', field: 'robotics' },
  { key: 'AI / ML', field: 'ai_ml' },
  { key: 'Testing', field: 'testing' },
  { key: 'Automotive', field: 'automotive' },
  { key: 'Tools', field: 'tools' }
];

const Expertise = () => {
  const { focus, skills, personal } = portfolioData;

  return (
    <section id="expertise">
      <h2 className="label reveal">Expertise</h2>

      <div className="chips reveal">
        {focus.chips.map((chip) => (
          <span className="chip" key={chip}>{chip}</span>
        ))}
      </div>

      <p className="body-text reveal">{focus.statement}</p>

      <div className="skill-list">
        {skillGroups.map(({ key, field }) => (
          <div className="skill-row reveal" key={key}>
            <span className="skill-key">{key}</span>
            <span className="skill-val">
              {skills[field].map((skill, i) => (
                <React.Fragment key={skill}>
                  {i > 0 && <> <span className="skill-sep">·</span> </>}
                  {skill}
                </React.Fragment>
              ))}
            </span>
          </div>
        ))}
        <div className="skill-row reveal">
          <span className="skill-key">Spoken</span>
          <span className="skill-val">
            {personal.languages.map((lang, i) => (
              <React.Fragment key={lang}>
                {i > 0 && <> <span className="skill-sep">·</span> </>}
                {lang}
              </React.Fragment>
            ))}
          </span>
        </div>
      </div>
    </section>
  );
};

export default Expertise;
